<template>
  <div class="flex flex-col items-center gap-[12px] w-full">
    <div class="pb-[12px] w-full">
      <h2 class="text-[28px] font-bold text-[#3a3d44] text-center leading-[1.3]">
        На вашу почту<br>отправлено письмо
      </h2>
    </div>
    <p class="text-sm text-primary">{{ email }}</p>
    <p class="text-sm text-[rgba(58,61,68,0.6)] text-center pb-[12px]">
      Перейдите по ссылке для подтверждения почты
    </p>
    <button
      class="bg-primary rounded-[12px] py-3 w-[368px] max-md:w-full text-white font-bold text-base"
      @click="resendEmail"
    >
      Отправить письмо еще раз
    </button>
    <div class="pt-[12px]">
      <span
        class="text-primary text-sm cursor-pointer"
        @click="$emit('setMode', LoginMode.AUTH_TELEGRAM)"
      >
        Вернуться назад
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LoginMode } from '~/interfaces/login/UI';
import AuthService from '~/services/AuthService';

const props = defineProps<{
  email: string;
  registrationId?: number;
}>();

defineEmits<{
  (e: 'setMode', mode: LoginMode): void;
}>();

const resendEmail = async () => {
  try {
    await AuthService.registerStart(props.email);
  } catch {
    // ignore
  }
};
</script>
